function HomePropertyTypesSection({ propertyTypes }) {
  return (
    <section className="bg-cream-200 py-20 lg:py-28" id="eiendomstyper">
      <div className="site-rail">
        <div className="max-w-[820px]">
          <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-sand-600">
            <span className="h-px w-8 bg-sand-500" />
            Eiendomstyper
          </p>
          <h2 className="mt-5 font-serif text-[clamp(2.2rem,4.6vw,3.6rem)] font-bold leading-[1.04] text-forest-900 text-balance">
            Vi leier ut ulike typer boliger og bygg.
          </h2>
        </div>
        <div className="mt-12 grid gap-6 md:grid-cols-2 xl:grid-cols-3" data-reveal data-stagger>
          {propertyTypes.map((propertyType, index) => (
            <article
              className="hover-lift group relative flex flex-col overflow-hidden rounded-[1.75rem] border border-forest-700/10 bg-white p-8 shadow-soft transition hover:border-forest-700/25"
              key={propertyType.title}
            >
              <span className="absolute right-6 top-6 font-serif text-5xl font-bold text-cream-200 transition group-hover:text-sand-300">
                0{index + 1}
              </span>
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-forest-700 text-cream-50 shadow-lg">
                <svg fill="none" height="28" viewBox="0 0 64 64" width="28" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 31.5L32 13L54 31.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
                  <path d="M16 29V51H48V29" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
                </svg>
              </span>
              <h3 className="mt-6 text-[1.5rem] font-bold text-forest-900">{propertyType.title}</h3>
              <p className="mt-3 text-[1.04rem] leading-[1.7] text-forest-500">{propertyType.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomePropertyTypesSection;